module.exports = __webpack_public_path__ + "img/share.2ad367b0.jpg";